import './local_menu.scss';

let a_elem = $('#region_list a');
let form = $('#loc_form');             // eslint-disable-line
let input = $('#loc_form :input');      // eslint-disable-line

a_elem.click(function (e) {
  e.preventDefault();
  e.stopPropagation();

  let $this = this;
  let link = $this.href;
  // let deflang    = $this.dataset.deflang;                                     // eslint-disable-line
  // let originUrl  = window.location.origin;                                    // eslint-disable-line
  //let actualLink = link.replace(`${originUrl}/${deflang}/`, `${originUrl}/`); // eslint-disable-line
  let JsonData = JSON.stringify({
    iso: $this.dataset.iso,
    country: $this.dataset.country,
    lang: $this.dataset.lang,
    label: $this.outerText,
    flag: $($this).find('img').attr('src'),
    url: link,
  });

  input.val(JsonData);
  form.attr('action', link);

  form.submit();

});



// WEBPACK FOOTER //
// ./resources/views/partials/index/local_menu_popap/local_menu.js